import { defaultColumns, defaultSort } from '../../components/reports/pareto/columns';

export default {
  state: {
    pareto: [],
    paretoByCountries: [],
    tableConfig: null,
    loading: false,
    filterString: {
      shop_limit: 60,
    },
    sorting: {
      prop: 'gross_price',
      order: 'desc',
      shop_limit: 60,
    },
  },
  getters: {
    pareto: state => state.pareto,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    paretoByCountries: state => state.paretoByCountries,
  },
  mutations: {
    setParetoByCountries(state, paretoByCountries) {
      state.paretoByCountries = paretoByCountries;
    },
    setPareto(state, pareto) {
      state.pareto = pareto;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/pareto-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'pareto-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const pareto = await axios.get('api/reports/pareto' + (query || ''));
        commit('setPareto', pareto);
        // dispatch('fetchByShops', queryString);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetchByShops({ commit, state, dispatch }, queryString = null) {
      const paretoByCountries = await axios.get('api/reports/pareto' + (queryString || ''));
      commit('setParetoByCountries', paretoByCountries);
    }
  },
};
